import { memo, useCallback, useEffect, useState } from 'react';

import { Modal, Tab, TabContent, TabItem, TabNav, TabPane, Text } from '@/lib/v2/components';
import { TabItemProps } from '@/lib/v2/components/Tab/TabItem';
import { TabPaneProps } from '@/lib/v2/components/Tab/TabPane';

interface ModalActionCreationProps {
  isOpen: boolean;
  title?: string;
  icon?: JSX.Element;
  onClose: () => void;
  tabItems: TabItemProps[];
  tabPanes: TabPaneProps[];
  currentTab: string | number;
}

const ModalActionCreation = ({
  isOpen,
  icon,
  title,
  onClose,
  tabItems,
  tabPanes,
  currentTab,
}: ModalActionCreationProps) => {
  const [activeTab, setActiveTab] = useState(currentTab);

  const handleTabClick = useCallback((tabId: string | number) => {
    setActiveTab(tabId);
  }, []);

  useEffect(() => {
    setActiveTab(currentTab);
  }, [currentTab]);

  return (
    <Modal noPadding withAuto externalClose={true} open={isOpen} onClose={onClose}>
      <div className="flex h-[732px] min-h-[732px] w-[90vw] flex-col md:w-[80vw] xl:h-auto 2xl:w-[70vw]">
        <div className="flex w-full items-center gap-2 border-b px-6 py-4">
          {icon}
          <Text fontWeight="medium" variant="sub-headline">
            {title}
          </Text>
        </div>
        <div className="relative h-full w-full overflow-hidden px-6 py-4">
          <Tab currentTab={activeTab}>
            <TabNav>
              {tabItems.map((tab) => {
                const { tabId, onClick, ...restTabProps } = tab;
                return (
                  <TabItem
                    key={tabId}
                    tabId={tabId}
                    onClick={(e) => (handleTabClick(tab.tabId), onClick?.(e))}
                    {...restTabProps}
                  />
                );
              })}
            </TabNav>
            <TabContent className="overflow-y-scroll xl:overflow-hidden">
              {tabPanes.map((pane) => {
                const { tabId, children } = pane;
                return (
                  <TabPane key={tabId} tabId={tabId}>
                    {children}
                  </TabPane>
                );
              })}
            </TabContent>
          </Tab>
        </div>
      </div>
    </Modal>
  );
};

export default memo(ModalActionCreation);
